var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readyToRender)?_c('div',{staticClass:"hidden"},[_c('GlobalJs',{attrs:{"widgetsData":_vm.widgetsData,"widgetsComputed":_vm.widgetsComputed}}),_vm._v(" "),_c('ScopedJs',{attrs:{"widgetsData":_vm.widgetsData,"widgetsComputed":_vm.widgetsComputed}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68dcffa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomCodeRender/index.vue
// module id = null
// module chunks = 